import styled, { css } from 'styled-components';
import {
  FootnoteMixin,
  Heading2Mixin,
  Heading4Mixin,
  TableTitleMixin,
} from '@qover/typography';

export const SummaryHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const SummaryCardContainer = styled.div`
  background-color: ${props => props.theme.colors.cardBackground()};
  border-radius: ${props => props.theme.borders.cardRadius};
  box-shadow: 0 2px 4px 0 ${props => props.theme.colors.textQuote(0.15)};
  color: ${props => props.theme.colors.textQuote()};
  padding: 20px;

  @media (min-width: ${props => props.theme.breakpoints.minWidth.S}) {
    padding: 40px;
  }

  ${SummaryHeaderContainer} + *,
  h4 + * {
    margin-top: 20px;
  }

  h2 {
    ${Heading2Mixin};
    margin: 0;
  }

  h4 {
    ${Heading4Mixin};
    margin: 20px 0 0;

    @media (min-width: ${props => props.theme.breakpoints.minWidth.S}) {
      margin: 40px 0 0;
    }
  }

  ul {
    margin-bottom: 0;
    margin-top: 12px;
    list-style: none;

    li {
      ${FootnoteMixin};
      display: flex;

      & > *:first-child {
        width: 50%;
      }
    }

    li + li {
      margin-top: 12px;
    }
  }
`;

export const SummarySideCardMixin = css`
  border-radius: 4px;
  background-color: var(--color-card-background-100);
  padding: 20px;
`;

export const Price = styled.span`
  ${TableTitleMixin};
  font-weight: bold;
  text-align: right;
`;

export const SideCartSectionBackground = styled.div`
  background-color: transparent;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  max-width: 270px;
  width: 100%;

  > div + div {
    margin-top: 20px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.minWidth.S}) {
    margin: 0;
    margin-left: 20px;
  }
`;
